import PropTypes from "prop-types";
import { useController } from "react-hook-form";

import AsyncSelect from "@/components/async-select";

export default function AsyncSelectField(props) {
    const {
        name,
        label,
        rules = {},
        loadOptions,
        onOptionSelect,
        defaultValue,
        disable,
        defaultOptionsDependency,
        ...restProps
    } = props;
    const { field, fieldState } = useController({ name, defaultValue, rules });

    const handleChange = (option) => {
        onOptionSelect?.(option);
        field.onChange(option?.value ?? "");
    };

    return (
        <AsyncSelect
            {...restProps}
            label={label}
            value={field.value}
            onChange={handleChange}
            loadOptions={loadOptions}
            error={fieldState.error?.message}
            disabled={disable ?? restProps.disabled}
            defaultOptionsDependency={defaultOptionsDependency}
        />
    );
}

AsyncSelectField.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    rules: PropTypes.object,
    loadOptions: PropTypes.func.isRequired,
    onOptionSelect: PropTypes.func,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disable: PropTypes.bool,
    defaultOptionsDependency: PropTypes.any,
};
